import React, { Component } from 'react';

import get from 'lodash/get';
import map from 'lodash/map';
import range from 'lodash/range';
import find from 'lodash/find';
import lowerCase from 'lodash/lowerCase';
import PdfPlainInputs from './PdfPlainInputs';
import { Page, Text, Document, StyleSheet, View, Image } from '@react-pdf/renderer';

const PRIMARY_ORANGE = '#f06024';
const PRIMARY_BLUE = '#153b62';
const BORDER_COLOR = '#000';
const BORDER_STYLE = 'solid';
const COL1_WIDTH = 10;
const COLN_WIDTH = '10em';

class PdfFieldProcessor extends Component {
  constructor() {
    super();

    this.state = {
      selectValue: '',
      newRowValue: 5,
      mandatoryText: 'Please answer',
      addBtn: 'Add Row',
      selectionText: {
        start: 'Select up to ',
        end: 'domaines',
      },
    };
  }

  processQuestion = (questionDef, titleKey, valueKey) => {
    let baseQuestion = questionDef.map((questionItem, index) => (
      <View key={index}>
        <Text style={styles.question}>{get(questionItem, titleKey)}</Text>
        {
          <PdfFieldProcessor
            titleKey={titleKey}
            valueKey={valueKey}
            question={questionItem}
            key={index}
            responses={this.props.responses}
          />
        }
      </View>
    ));

    return baseQuestion;
  };

  mapControlTypes = (field, index, response = '', titleKey, valueKey) => {
    let fieldType;

    const { control, type, choices, question_id, id } = field;

    switch (control) {
      case 'input':
        type === 'dropdown'
          ? (fieldType = (
              <View>
                <Text style={styles.answer}>
                  {typeof response !== 'object' && response.toString()}
                </Text>
              </View>
            ))
          : (fieldType = (
              <View key={index}>
                <PdfPlainInputs
                  itemValue={field[valueKey]}
                  options={choices || []}
                  title={field[titleKey] || field[valueKey]}
                  key={index}
                  fieldId={id}
                  nameVal={question_id}
                  nature={type}
                  response={response}
                />
              </View>
            ));
        break;
      case 'date':
        fieldType = response;
        break;
      default:
        break;
    }

    return fieldType;
  };

  render() {
    const { question, responses, titleKey, valueKey } = this.props;

    const { fields, additional_field, id } = question;

    const specialFieldsType =
      get(find(fields, ['type', 'checkbox']), 'type', '') ||
      get(find(fields, ['type', 'radio']), 'type', '') ||
      get(find(fields, ['type', 'date']), 'type', '') ||
      get(find(fields, ['type', 'table']), 'type', '');

    let specialFields, currentKey, defaultValue, valueTriggered, valueInResponse;

    currentKey = id;

    switch (specialFieldsType) {
      case 'checkbox':
        defaultValue = map(get(responses, currentKey), value => value);

        specialFields = (
          <View>
            <Text style={styles.answer}>{defaultValue.join(', ')}</Text>
          </View>
        );
        break;
      case 'radio':
        defaultValue = map(get(responses, currentKey), value => value)[0];

        valueInResponse =
          lowerCase(defaultValue) === lowerCase(get(additional_field, `trigger_${valueKey}`)) &&
          !valueTriggered;

        specialFields = (
          <View>
            <Text style={styles.answer}>{defaultValue}</Text>
            {get(additional_field, 'questions') && valueInResponse
              ? this.processQuestion(get(additional_field, 'questions'), titleKey, valueKey)
              : null}
          </View>
        );
        break;
      case 'date':
        let fieldId = get(find(fields, ['type', 'date']), 'id');

        defaultValue = get(get(responses, currentKey, ''), fieldId, '').toString();

        specialFields = (
          <View>
            <Text style={styles.answer}>{defaultValue}</Text>
          </View>
        );
        break;
      case 'table':
        let table = fields[0];

        let tableColumns = get(table, 'columns', []);

        let tableRows = get(table, 'rows', this.state.newRowValue);

        let rowCount = range(0, tableRows, 1);

        defaultValue = get(responses, currentKey, []);

        let inputRows = rowCount.map((row, rowNumber) => {
          let columns = tableColumns.map(fieldDef => {
            let inputKey = `${currentKey}[${rowNumber}].${get(fieldDef, 'id')}`;

            let columnValue =
              (defaultValue.length && defaultValue[rowNumber][get(fieldDef, 'id')]) || '';

            return (
              <View style={styles.tableCol} key={inputKey}>
                <Text style={styles.answer}>{columnValue}</Text>
              </View>
            );
          });

          return (
            <View style={styles.tableRow} key={rowNumber}>
              {columns}
            </View>
          );
        });

        let baseWidth = 250;

        let headers = tableColumns.map((column, i) => {
          return (
            <View style={styles.tableColHeader} key={i}>
              <Text style={styles.tableCellHeader}>{get(column, titleKey, '')}</Text>
            </View>
          );
        });

        specialFields = (
          <View style={styles.table}>
            <View style={styles.tableRow}>{headers}</View>
            <View style={styles.table}>{inputRows}</View>
          </View>
        );
        break;
      default:
        let normalFields = fields.map((fieldDef, index) => {
          defaultValue =
            get(get(responses, currentKey, ''), get(fieldDef, 'id')) ||
            get(responses, currentKey, '');

          let field = (
            <View key={index}>
              {this.mapControlTypes(fieldDef, index, defaultValue, titleKey, valueKey)}
            </View>
          );

          return field;
        });

        specialFields = <View>{normalFields}</View>;
        break;
    }

    return <View className="question-list__item__question-inputs">{specialFields}</View>;
  }
}

export default PdfFieldProcessor;

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 18,
    textAlign: 'center',
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    textAlign: 'center',
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    color: '#000',
  },
  question: {
    color: PRIMARY_BLUE,
    fontSize: 15,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    paddingBottom: '1rem',
  },
  questionTitle: {
    color: PRIMARY_BLUE,
    borderBottomColor: PRIMARY_ORANGE,
    borderBottomWidht: 1,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 14,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  answer: {
    color: PRIMARY_ORANGE,
    fontSize: 12,
  },
  table: {
    display: 'flex',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomColor: BORDER_COLOR,
  },
  tableHeader: {
    margin: 'auto',
    flexDirection: 'row',
    borderColor: BORDER_COLOR,
  },
  tableCol1Header: {
    width: COL1_WIDTH + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColHeader: {
    width: COLN_WIDTH + '%',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol1: {
    width: COL1_WIDTH + '%',

    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: COLN_WIDTH + '%',
    // borderStyle: BORDER_STYLE,
    // borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    // margin: 5,
    fontSize: 12,
    fontWeight: 500,
    borderBottomColor: '#000',
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
});



// WEBPACK FOOTER //
// ./src/components/CDRSections/Responses/ResponsesDownload/PdfFieldProcessor.js